import React from 'react';
import IconButton from 'material-ui/IconButton';
import Info from 'material-ui/svg-icons/action/info';
import { Row, Col } from 'react-flexbox-grid';

import HistoryEntry from 'components/HistoryEntry';
import HistoryEntryHeader from 'components/HistoryEntryHeader';
import HistoryEntryColumns from 'components/HistoryEntryColumns';
import HistoryEntryColumn from 'components/HistoryEntryColumn';
import CommonHistoryEntryControls from 'routes/Documents/components/CommonHistoryEntryControls';
import CommonViewButton from 'routes/Documents/components/CommonViewButton';
import { getLatestFinishedCommitData } from 'lib/documentHandling';

import { formatHeaderDate, editTimeLeft } from 'lib/dateDisplay';
import { colors, dimensions } from 'styles/provider';
import { dateFromPartial, isPartialDate } from 'neuro-utils';

const styles = {
  color: colors.clrSecondary,
  button: {
    width: dimensions.infoButtonSize,
    height: dimensions.infoButtonSize,
    boxSizing: 'content-box',
    padding: 0,
  },
  icon: {
    width: dimensions.infoIconSize,
    height: dimensions.infoIconSize,
  },
};

export const sorter = docs =>
  docs.sort(
    (d1, d2) =>
      (isPartialDate(d2?.content?.date) ? dateFromPartial(d2.content.date) : d2.createDate) -
      (isPartialDate(d1?.content?.date) ? dateFromPartial(d1.content.date) : d1.createDate),
  );

const msg = id => ({ id });

const renderEntryHeader = (doc, fm) => `${formatHeaderDate(doc.createDate)}`;

const renderHeader = m => <p children={m} />;

const historyMapper =
  (name, edit, view, setDialog) =>
  (d, { formatMessage }) => (
    <HistoryEntry key={d.documentId}>
      <HistoryEntryHeader title={renderEntryHeader(d, formatMessage)} active={editTimeLeft(d.createDate)}>
        {editTimeLeft(d.createDate) && (
          <CommonHistoryEntryControls
            time={d.createDate}
            action={() => edit(name, d.documentId, getLatestFinishedCommitData(d))}
          />
        )}
        {(window.__ROLE__ === 'DOCTOR' || !editTimeLeft(d.createDate)) && (
          <CommonViewButton onView={e => view('msnq', d.documentId)} />
        )}
      </HistoryEntryHeader>
      <HistoryEntryColumns>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('msnq.labels.filled')))}>
          <p>{d.filled + ' / 15'}</p>
        </HistoryEntryColumn>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('msnq.labels.score')))}>
          <Row middle="xs">
            <Col xs={3} sm={2} md={1}>
              {d.score}
            </Col>
            {d.filled === 15 && (
              <Col>
                <IconButton style={{ ...styles.button }} iconStyle={styles.icon} onClick={setDialog(d, 'msnq')}>
                  <Info color={styles.color} />
                </IconButton>
              </Col>
            )}
          </Row>
        </HistoryEntryColumn>
      </HistoryEntryColumns>
    </HistoryEntry>
  );

export default historyMapper;
